var map = {
	"./cs-Czech-mac.json": 86785,
	"./cs-Czech-pc.json": 36070,
	"./da-Danish-mac.json": 75112,
	"./da-Danish-pc.json": 23916,
	"./de-German-mac.json": 24571,
	"./de-German-pc.json": 98263,
	"./de-Swiss_German-mac.json": 90974,
	"./de-Swiss_German-pc.json": 49100,
	"./en-British-mac.json": 93349,
	"./en-British-pc.json": 3378,
	"./en-Colemak-mac.json": 22613,
	"./en-Dvorak-mac.json": 63995,
	"./en-Dvorak-pc.json": 53303,
	"./en-Dvorak_Lefthanded-mac.json": 77520,
	"./en-Dvorak_Lefthanded-pc.json": 15490,
	"./en-Dvorak_Righthanded-mac.json": 92652,
	"./en-Dvorak_Righthanded-pc.json": 23913,
	"./en-US-mac.json": 96417,
	"./en-US-pc.json": 49506,
	"./es-Spanish-mac.json": 63515,
	"./es-Spanish-pc.json": 46793,
	"./fr-Bepo-pc.json": 54014,
	"./fr-Canadian_French-mac.json": 15810,
	"./fr-Canadian_French-pc.json": 58340,
	"./fr-French-mac.json": 63692,
	"./fr-French-pc.json": 58278,
	"./fr-Swiss_French-mac.json": 19064,
	"./fr-Swiss_French-pc.json": 57319,
	"./hu-Hungarian-mac.json": 68939,
	"./hu-Hungarian-pc.json": 42302,
	"./it-Italian-mac.json": 89873,
	"./it-Italian-pc.json": 64296,
	"./nb-Norwegian-mac.json": 58230,
	"./nb-Norwegian-pc.json": 38071,
	"./nl-Dutch-mac.json": 5348,
	"./nl-Dutch-pc.json": 46997,
	"./pl-Polish-mac.json": 2121,
	"./pl-Polish-pc.json": 65151,
	"./pt-Brazilian-mac.json": 57122,
	"./pt-Portuguese-mac.json": 56736,
	"./pt-Portuguese-pc.json": 24401,
	"./ro-Romanian-mac.json": 47278,
	"./ro-Romanian-pc.json": 86424,
	"./sv-Swedish-mac.json": 72811,
	"./sv-Swedish-pc.json": 59922,
	"./tr-Turkish_Q-mac.json": 98447,
	"./tr-Turkish_Q-pc.json": 76138
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5165;